import { createTheme, alpha } from '@mui/material/styles';

export const BRAND_GRADIENT = 'linear-gradient(135deg, #0d7a5f 0%, #0f5ca0 100%)';
export const BRAND_GREEN    = '#0d7a5f';
export const BRAND_BLUE     = '#1565c0';

const theme = createTheme({
  palette: {
    primary: {
      main:          BRAND_GREEN,
      light:         '#3da882',
      dark:          '#095340',
      contrastText:  '#fff',
    },
    secondary: {
      main:          BRAND_BLUE,
      light:         '#4286d0',
      dark:          '#0d47a1',
      contrastText:  '#fff',
    },
    background: {
      default: '#f4f6f8',
      paper:   '#ffffff',
    },
  },
  shape: { borderRadius: 10 },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    button: { textTransform: 'none', fontWeight: 600 },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root:            { textTransform: 'none', fontWeight: 600 },
        containedPrimary: { background: BRAND_GRADIENT, '&:hover': { background: 'linear-gradient(135deg, #0a6050 0%, #0d47a1 100%)' } },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: { background: BRAND_GRADIENT, boxShadow: '0 2px 12px rgba(13,122,95,0.25)' },
      },
    },
    MuiPaper:  { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiCard:   { styleOverrides: { root: { backgroundImage: 'none' } } },
    MuiTableHead: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            background:  alpha(BRAND_GREEN, 0.08),
            fontWeight:  700,
            color:       BRAND_GREEN,
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        colorPrimary: { background: alpha(BRAND_GREEN, 0.12), color: BRAND_GREEN },
      },
    },
  },
});

export default theme;
